import {useState} from "react";
import {useUpdateTechnician} from "../../../hooks/useUpdateUser";

const Bio = ({bio, techId}) => {
  const [Bio, setBio] = useState(bio);
  const {onUpdateTech, isLoadingUpdate} = useUpdateTechnician();
  const handleSubmit = () => {
    onUpdateTech({id: techId, body: {bio: Bio}});
  };

  return (
    <div className="w-full flex flex-col justify-start p-6 items-start h-full gap-4  ">
      <h6 className="font-semibold text-xl">Ma description :</h6>

      <div className="form-group mb-3 w-full ">
        <textarea
          type="text"
          rows={8}
          className="form-control"
          onChange={(e) => setBio(e.target.value)}
          value={Bio}
        />
      </div>

      {/* <div className="flex w-full justify-center gap-1 lg:gap-3 mt-4 lg:justify-end flex-wrap-reverse  ">
        <button
          className="btn border-none underline underline-offset-2 min-w-[200px] w-[200px] !rounded-lg"
          onClick={() => setBio(bio)}
        >
          Annuler
        </button>
        <button
          className="btn !bg-[#FF6600] text-white min-w-[300px] w-1/5 !rounded-lg"
          onClick={() => handleSubmit()}
        >
          Enregistrer
        </button>
      </div> */}
      <div className="flex justify-center gap-1 w-full lg:gap-3 mt-4 lg:justify-end flex-wrap-reverse px-[15px] ">
        <button
          className="btn !min-w-[250px] !rounded-lg bg-white !text-[#0D44B1] !border-[#0D44B1] !border border-solid"
          type="reset"
          disabled={isLoadingUpdate}
          onClick={() => setBio(bio)}
        >
          Annuler
        </button>
        <button
          className="btn !min-w-[250px] !rounded-lg bg-gradient-to-r from-[#0022AA] to-[#1A64B9] text-white"
          type="submit"
          onClick={() => handleSubmit()}
          disabled={isLoadingUpdate}
        >
          {isLoadingUpdate ? "Enregistrement..." : "Enregistrer"}{" "}
        </button>
      </div>
    </div>
  );
};

export default Bio;
